export default `/* Ids Tooltip Component - Most Styles are in Popup */
:host {
  display: none;
  font-weight: normal;
}

:host([visible]) {
  display: inline;
}

.ids-popup.tooltip.standalone {
  position: relative;
}

ids-popup[dir=rtl]::part(arrow)::after, ids-popup[dir=rtl]::part(arrow-top)::after, ids-popup[dir=rtl]::part(arrow-right)::after, ids-popup[dir=rtl]::part(arrow-bottom)::after, ids-popup[dir=rtl]::part(arrow-left)::after {
  display: none;
}

ids-popup[arrow=top]::part(arrow-left)::after {
  display: none;
}

.adjust-whitespace {
  white-space: pre-wrap;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtdG9vbHRpcCIsInNvdXJjZXMiOlsiaWRzLXRvb2x0aXAuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtBQUNBO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRTs7O0FBSUY7RUFDRTs7O0FBS0E7RUFLRTs7O0FBS0Y7RUFDRTs7O0FBSUo7RUFDRSIsInNvdXJjZXNDb250ZW50IjpbIi8qIElkcyBUb29sdGlwIENvbXBvbmVudCAtIE1vc3QgU3R5bGVzIGFyZSBpbiBQb3B1cCAqL1xuOmhvc3Qge1xuICBkaXNwbGF5OiBub25lO1xuICBmb250LXdlaWdodDogbm9ybWFsO1xufVxuXG46aG9zdChbdmlzaWJsZV0pIHtcbiAgZGlzcGxheTogaW5saW5lO1xufVxuXG4vLyBVc2VkIGZvciBwb3NpdGlvbmluZyBJZHNUb29sdGlwcyBpbiBzdGFuZGFsb25lLWNzcyBtb2RlXG4uaWRzLXBvcHVwLnRvb2x0aXAuc3RhbmRhbG9uZSB7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbn1cblxuLy8gQWRqdXN0IFN0dWZmIGZvciBSVExcbmlkcy1wb3B1cFtkaXI9J3J0bCddIHtcbiAgJjo6cGFydChhcnJvdyk6OmFmdGVyLFxuICAmOjpwYXJ0KGFycm93LXRvcCk6OmFmdGVyLFxuICAmOjpwYXJ0KGFycm93LXJpZ2h0KTo6YWZ0ZXIsXG4gICY6OnBhcnQoYXJyb3ctYm90dG9tKTo6YWZ0ZXIsXG4gICY6OnBhcnQoYXJyb3ctbGVmdCk6OmFmdGVyIHtcbiAgICBkaXNwbGF5OiBub25lO1xuICB9XG59XG5cbmlkcy1wb3B1cFthcnJvdz0ndG9wJ10ge1xuICAmOjpwYXJ0KGFycm93LWxlZnQpOjphZnRlciB7XG4gICAgZGlzcGxheTogbm9uZTtcbiAgfVxufVxuXG4uYWRqdXN0LXdoaXRlc3BhY2Uge1xuICB3aGl0ZS1zcGFjZTogcHJlLXdyYXA7XG59XG4iXX0= */`;
